import fr from 'facet-rest';
import React from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useUserContext from 'Context/UserContext';
import AccordionList from 'Components/UI/TabularAccordionList';
import PropTypes from 'prop-types';
import { AccordionListProvider } from 'Components/UI/TabularAccordionList/AccordionListContext';
import SCHEMA from './clientExperienceSchema';
import ClientExperienceAccordionContent from './ClientExperienceAccordionContent';
import ClientExperienceQueryWidget from './ClientExperienceQueryWidget';

function ClientExperienceAccordionList({ classes }) {
  const { userResource } = useUserContext();
  const link = userResource.relationship(
    fr.relationships.clientExperience.name,
  ).link('related');

  return (
    <AccordionListProvider
      schema={SCHEMA}
      link={link}
      defaultOrder={{
        attrName: 'renewalDate',
        direction: 'desc',
      }}
    >
      <div className={classes.root}>
        <ClientExperienceQueryWidget />
        <div className={classes.listContainer}>
          <AccordionList
            AccordionContentComponent={ClientExperienceAccordionContent}
          />
        </div>
      </div>
    </AccordionListProvider>
  );
}

ClientExperienceAccordionList.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(() => ({
  root: {
    display: 'flex',
  },
  listContainer: {
    flexGrow: 1,
  },
}))(ClientExperienceAccordionList);
